import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../constants/common'
import { useFloatingSelect } from '../../hooks'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../Button'
import { FloatingSelectDropdown } from '../Floating'

import { QA_NAME_MORE_BUTTON } from './MoreActionsButton.constants'

import * as styles from './MoreActionsButton.module.css'

function MoreActionsButton({
  actions,
  actionsClassName = styles.actions,
  disabled,
  text,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.bottom,
}) {
  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({ placement: tooltipPlacement })

  const { setReference } = refs

  function handleClick() {
    setOpen(isOpen => !isOpen)
  }

  function getHandleClickAction(action) {
    return event => {
      setOpen(false)

      action.onClick(event)
    }
  }

  return (
    <>
      <div ref={setReference}>
        <ButtonArrow
          disabled={disabled}
          getTooltip={null}
          height={BUTTON_HEIGHT_24}
          iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
          isGrey={false}
          isOpen={isOpen}
          qaName={QA_NAME_MORE_BUTTON}
          text={text}
          onClick={handleClick}
        />
      </div>
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <div className={actionsClassName}>
          {actions.map(action => (
            <action.Component
              {...action}
              className={classNames(styles.action, action.className)}
              key={action.key}
              text={action.text}
              tooltip={action.tooltip}
              onClick={getHandleClickAction(action)}
            />
          ))}
        </div>
      </FloatingSelectDropdown>
    </>
  )
}

export default MoreActionsButton
